import React, { ReactNode } from 'react';
import { Fade, Slide, Grow } from '@mui/material';

type AnimationType = 'fade' | 'slide' | 'grow';

interface HiddenProps {
  isVisible: boolean;
  animation?: AnimationType;
  children: ReactNode;
}

const Hidden: React.FC<HiddenProps> = ({
                                         isVisible,
                                         animation = 'fade',
                                         children,
                                       }) => {
  switch (animation) {
    case 'slide':
      return (
        <Slide  in={isVisible} direction="down" mountOnEnter unmountOnExit>
          <div>{children}</div>
        </Slide>
      );
    case 'grow':
      return (
        <Grow in={isVisible} mountOnEnter unmountOnExit>
          <div>{children}</div>
        </Grow>
      );
    case 'fade':
    default:
      return (
        <Fade in={isVisible} mountOnEnter unmountOnExit>
          <div>{children}</div>
        </Fade>
      );
  }
};

export default Hidden;
